import { campaignService } from 'services'
import {browserHistory} from 'react-router';
import {reset} from 'redux-form';

import shortid from 'shortid';
import * as appActions from './app';
export const CREATE_BEGIN = 'campaigns/CREATE_BEGIN';
export const CREATE_SUCCESS = 'campaigns/CREATE_SUCCESS';
export const GET_SUCCESS = 'campaigns/GET_SUCCESS';
export const GET_ERROR = 'campaigns/GET_ERROR';
export const GET_ALL_SUCCESS = 'campaigns/GET_ALL_SUCCESS';
export const GET_ALL_ERROR = 'campaigns/GET_ALL_ERROR';
export const EDIT = 'campaigns/EDIT'

export function getSuccess(campaign){
    return {
        type: GET_SUCCESS,
        campaign: campaign
    }
}

export function getError(){
    return {
        type: GET_ERROR
    }
}
export function getAllSuccess(campaigns){
    return {
        type: GET_ALL_SUCCESS,
        list: campaigns
    }
}

export function getAllError(){
    return {
        type: GET_ALL_ERROR
    }
}

export function getAll(){
    return (dispatch) =>{
        campaignService().getAll().then((res)=>{
            dispatch(getAllSuccess(res.data));
    
        }).catch((e)=>{
            dispatch(getAllError());
        });
    }
}

export function createSuccess(){
    return {
        type: CREATE_SUCCESS
    }
}

export function createBegin(){
    return {
        type: CREATE_BEGIN
    }
}

export function create(campaign){
    let data={
        ...campaign,
        id: campaign.id || shortid.generate()
    }

    return (dispatch) =>{
        dispatch(createBegin());
        campaignService().create(data).then(()=>{
            dispatch(createSuccess());
            browserHistory.push('/dashboard');
            dispatch(getAll());
        });
    }
}

export function editSuccess(id){
    return {
        type: EDIT,
        id: id
    }
}


export function edit(id, form){
    return (dispatch)=>{
        campaignService().getAll().then((res)=>{
            if (form)
            dispatch(reset(form))
            dispatch(getAllSuccess(res.data));
            dispatch(editSuccess(id));
        }).catch(()=>{
            dispatch(getAllError());
        });
    }
}

export function update(campaign, form){
    return (dispatch)=>{
        campaignService().update(campaign).then(()=>{
            //dispatch(getAll());
            dispatch(edit(campaign.id, form))
        })
    }
}

export function get(id){
    return (dispatch)=>{
        campaignService().get(campaign.id).then((campaign)=>{
            dispatch(getSuccess(campaign));
        })
    }  
}

export function getPublic(id){
    return (dispatch)=>{
        campaignService().public(campaign.id).then((campaign)=>{
            dispatch(getSuccess(campaign));
        })
    }  
}

export function remove(campaign){
    return (dispatch)=>{
        campaignService().remove(campaign).then(()=>{
            dispatch(getAll());
        })
    }
}

const reducer = (state = {
    list: null,
    single: null,
    created: false
  } , action = {}) => {

  switch (action.type) {
    case GET_ALL_SUCCESS: {
        return {
            ...state,
            list: [...action.list]
        }
    }
    case CREATE_BEGIN:
        return {
            ...state,
            created: false
        }
    case CREATE_SUCCESS:
        return {
            ...state,
            created: true
        }
    case GET_ALL_ERROR: {
        return {
            ...state,
            list: []
        }
    }
    case EDIT: {
        let l = [];
        l = state.list.map((c) => {

            if (c.id === action.id) {
                c.selected = true;
            } else {
                c.selected = false;
            }

            return { ...c };
        });        
        return {
            ...state,
            list: l
        }
    }
    case appActions.REQUEST_SUCCESS: {
        return {
            ...state,
            single: {...action.data}
        }
    }
    case GET_SUCCESS: {
        return {
            ...state,
            single: {
                ...action.campaign
            }
        }
    }

    case GET_ERROR: {
        return {
            ...state,
            single: null
        }
    }
    default:
      return state
  }
}

export default reducer;



// WEBPACK FOOTER //
// app/modules/campaigns.js